import moment from "moment";
import { ListingProperties } from "../types/listing.type";
import { OfficeProperties } from "../types/office.type";

export const PAGE_SIZE_OPTIONS = ["25", "50", "100"];

const date = new Date();

export const now = moment().format("MMMM DD, yyyy");
export const appVersion: string | undefined = process.env.REACT_APP_VERSION_NAME;
export const thisYear = date.getFullYear();

export const getInitialName = (name: string) => {
	const split: string[] = name.split(" ");

	let start = 0;
	let initial = [];

	if (split.length > 1) {
		while (start <= 1) {
			initial.push(split[start].charAt(0));
			start++;
		}
	} else {
		initial.push(split[0].substr(0, 2));
	}

	return initial.join("").toUpperCase();
};

export const formatDate = (date: string | number | Date) => {
	if (date) {
		const formated = moment(date).format("DD MMM yyyy");
		return formated;
	}
	return "";
};

export const formatTime = (time: string | Date) => {
	if (time) {
		const formated = moment(time).format("HH:mm");
		return formated;
	}
	return "";
};

export const formatUrlParams = (value: string) => {
	const param = value.split(" ").join("-").toLowerCase();
	return param;
};

export const formatMonth = (date: string | Date) => {
	if (date) {
		const formated = moment(date).format("MMM yyyy");
		return formated;
	}
	return "";
};
export const formatMultiDate = (dates: Array<string | Date>) => {
	var result = "";
	var prevMonth = "";
	dates.forEach((date) => {
		let parse = moment(date);
		let monthYear = parse.format("MMM yyyy");
		if (prevMonth !== monthYear && result !== "") {
			result += " " + prevMonth;
		}
		if (result !== "") {
			result += ", ";
		}
		result += parse.format("DD");
		prevMonth = monthYear;
	});
	result += " " + prevMonth;
	return result;
};
export const formatUcWords = (str?: string) => {
	return str?.toLowerCase().replace(/\b[a-z]/g, function (letter) {
		return letter.toUpperCase();
	});
};
export const truncateString = (input: string, length: number = 100) =>
	input && input.length > length ? `${input.substring(0, length)}...` : input;

export const formatOfficeAddress = (office?: OfficeProperties) => {
	if (!office) return undefined;

	return office.address + ", " + office.city;
};
export const formatListingAddress = (listing?: ListingProperties) => {
	if (!listing) return undefined;
	const joined = [];
	if (listing.streetName) {
		joined.push(listing.streetName);
	}
	if (listing.district) {
		joined.push(listing.district);
	}
	if (listing.province) {
		joined.push(listing.province);
	}

	return joined.join(", ");
};

export const formatLocation = (listing?: ListingProperties) => {
	return `${listing?.streetName} No.${listing?.houseNumber}, Kec.${listing?.district}, ${listing?.city}, ${listing?.province}, ${listing?.country} ${listing?.postalCode}`;
};

export const formatYearToTime = (date: any) => {
	if (date) {
		const formated = moment(date).format("DD MMM YYYY HH:mm");
		return formated;
	}
	return "";
};

export function checkDateInRange(startAt: string | Date, endAt: string | Date) {
	const today = moment().utc().startOf("day");
	const startDate = moment(startAt).utc().startOf("day");

	if (endAt) {
		const endDate = moment(endAt).utc().endOf("day");
		if (today.isBetween(startDate, endDate)) {
			return true;
		} else {
			return false;
		}
	} else {
		if (today >= startDate) {
			return true;
		} else {
			return false;
		}
	}
}
